import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { ApiHttpService } from 'cms/utils/http/api';

export default function VideoGalleriesController(props) {

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const courseFilter = searchParams.get('course');

  const [galleries, setGalleries] = useState(null);
  const [addModalIsOpen, setAddModalIsOpen] = useState(false);
  const [show_delete, setShowDelete] = useState(false);

  const { isLoading, data, refetch } = useQuery(
    ['videoGalleries', courseFilter],
    () => ApiHttpService.loadUserGalleries(undefined, courseFilter),
    {
      onSuccess: (data) => {
        if (data.results) {
          setGalleries(data.results)
        }
      },
    }
  );

  const closeModal = () => {
    setAddModalIsOpen(false)
  }

  const showDelete = (e) => {
    e.preventDefault();
    setShowDelete(!show_delete)
  }

  return {
    isLoading,
    galleries,
    setGalleries,
    closeModal,
    addModalIsOpen,
    setAddModalIsOpen,
    showDelete,
    show_delete
  };;
}
